// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hn-0";